module.exports = __webpack_public_path__ + "static/media/tutorial-macros-step1.b441a675.png";